export default __webpack_public_path__ + "static/Avenir-Heavy-05-2f694a16cfa899513e766780eada0c60.ttf";